import { render, staticRenderFns } from "./DatavizBar.vue?vue&type=template&id=bd124dfa&"
import script from "./DatavizBar.vue?vue&type=script&lang=js&"
export * from "./DatavizBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports